<template>
  <div>
    <div class="wrap password-wrap">
      <div class="top-header">
        <h3 v-if="isAccount == 0">비밀번호 재설정</h3>
        <h3 v-if="isAccount == 1">계정 확인하기</h3>
      </div>
      <div class="body-wrap">
        <h4 v-if="isAccount == 0">
          비밀번호 재설정을 위해 <br />
          아이디(이메일)를 입력해 주세요.
        </h4>

        <h4 v-if="isAccount == 1">
          계정 확인을 위해 <br />
          아이디(이메일)를 입력해 주세요.
        </h4>

        <ul class="mt-50">
          <li>
            <input type="text" placeholder="아이디(이메일)을 입력해 주세요. " v-model="input.userId" @focus="setFocus()" @blur="setBlur()" @keyup.enter="account()" @keyup="keyupEvent" />
          </li>
          <!-- 아이디(이메일)이 오류일 경우 -->
          <p class="txt-red" v-if="isEmail">등록되지 않은 아이디(이메일)입니다.</p>

          <!-- 아이디가 올바르게 확인이 되었을 경우 -->
          <li v-if="isSend">
            <input type="text" placeholder="인증코드를 1시간 내 입력해 주세요." v-model="codeInput.certiCode" @focus="setFocus()" @blur="setBlur()" @keyup.enter="account()" />
            <!-- 인증번호 재발송 -->
            <b class="check-img" @click="resend()"><img src="@/assets/img/go-back-arrow.svg" alt="재발송" /> 재발송</b>
          </li>

          <!-- 인증코드까지 확인 했을 경우 -->
          <!-- <li>
                        <input type="text" placeholder="새로운 비밀번호를 입력해 주세요.">
                    </li>
                    <p class="txt-red">영문+숫자+특수문자 8자리 이상으로 입력해 주세요.</p>
                    <li>
                        <input type="text" placeholder="비밀번호를 한번 더 입력해주세요.">
                    </li>
                    비밀번호가 제대로 입력되지 않았을 경우
                    <p class="txt-red">동일한 비밀번호를 입력해 주세요.</p>
                    -->
        </ul>
      </div>
      <div class="bnb-btn" :class="{ 'btn-static': isBtn }">
        <!-- 아이디 입력 시 class="active" 활성화 -->
        <button @click="account()" :class="{ active: isActive }">확인</button>
        <!-- 새로운 비밀번호를 입력 할 경우 노출, 비밀번호 입력 시 class="active"로 활성화 -->
        <!-- <button>비밀번호 재설정하기</button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { EmptyCheck, EmailFormatCheck } from "@/utils/validation";
export default {
  name: "password_account",
  data: () => ({
    input: {
      userId: "",
    },
    codeInput: {
      userId: "",
      certiCode: "",
    },
    isEmail: false,
    isSend: false,
    isActive: false,
    isBtn: false,
  }),
  props: {
    isAccount: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  mounted() {},
  methods: {
    setFocus() {
      this.isBtn = true;
    },
    setBlur() {
      this.isBtn = false;
    },

    keyupEvent() {
      if (!this.isSend) {
        if (this.input.email != "") {
          this.isActive = true;
        }
      }
    },
    account() {
      if (!this.isSend) {
        if (!EmptyCheck(this.input.userId, "이메일을 ") || !EmailFormatCheck(this.input.userId)) {
          this.isEmail = true;
          return false;
        } else {
          let form = new FormData();
          form.append("userId", this.input.userId);
          form.append("userLevel", "1");
          this.axios
            .post("/auth/findpw", form)
            .then((res) => {
              // console.log(res);
              if (res.data.success) {
                this.isEmail = false;
                this.isSend = true;
                alert("해당 아이디(이메일)로 비밀번호 재설정 메일을 발송하였으니, 확인 부탁 드립니다.");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (!EmptyCheck(this.codeInput.certiCode, "인증코드를 ")) {
          return false;
        } else {
          this.codeInput.userId = this.input.userId;
          let form = new FormData();
          form.append("userId", this.codeInput.userId);
          form.append("certiCode", this.codeInput.certiCode);
          form.append("userLevel", "1");
          this.axios
            .post("/auth/findpw/check", form)
            .then((res) => {
              // console.log(res);
              if (res.data.success) {
                if (res.data.message == "인증 성공") {
                  this.$store.commit("setUserInfoId", this.codeInput.userId);
                  let userIdx = btoa(res.data.contentinfo.userIdx);
                  this.$router.push({ name: "password_trans", params: { idx: userIdx, isAccount: this.isAccount } });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    resend() {
      console.log("abc");
    },
  },
};
</script>
